export default "__VITE_ASSET__8f3c0320__"